// Decide se vale gastar uma tentativa do registro. A regra e CONSERVADORA de
// proposito: so e 'definitivo' quando o servidor deu um motivo especifico e
// reproduzivel. Errar para o lado de tentar demais custa um contador feio;
// errar para o outro lado custa dado que nunca sobe.

export type ClasseDeErro = 'rede' | 'temporario' | 'definitivo'

export interface ErroDoServidor {
  message?: string
  code?: string
}

const PADRAO_REDE = /failed to fetch|network|fetch failed|load failed/i

// SQLSTATE: 5 caracteres. As classes abaixo sao de INFRAESTRUTURA (conexao,
// recursos, intervencao do operador, erro externo) -- tentar de novo resolve.
const CLASSES_DE_INFRAESTRUTURA = ['08', '53', '57', '58']

const SQLSTATE = /^[0-9A-Z]{5}$/
// O PostgREST tem codigo proprio: PGRST204 e "coluna fora do cache do schema",
// o sintoma classico de migration que faltou aplicar.
const CODIGO_POSTGREST = /^PGRST\d{3}$/

export function classificarErro(erro: ErroDoServidor | null | undefined): ClasseDeErro {
  if (PADRAO_REDE.test(erro?.message ?? '')) return 'rede'

  const codigo = erro?.code ?? ''
  if (CODIGO_POSTGREST.test(codigo)) return 'definitivo'
  if (!SQLSTATE.test(codigo)) return 'temporario'
  if (CLASSES_DE_INFRAESTRUTURA.includes(codigo.slice(0, 2))) return 'temporario'
  return 'definitivo'
}
